<h1 mat-dialog-title>Medical history from the patient app</h1>

<div mat-dialog-content class="irv">
    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

    <div class="irv-alert irv-alert--error" *ngIf="loadError">
        <mat-icon>error_outline</mat-icon>
        <div>{{ loadError }}</div>
    </div>

    <ng-container *ngIf="proposal">
        <p class="irv-intro">{{ data.patientName || 'The patient' }} added these in the patient app on {{ proposal.receivedAt | date: 'd MMM y' }}.
            File the ones you want in the patient's record; they are marked "Patient reported".</p>

        <div class="irv-alert" *ngIf="proposal.status !== 'pending'">
            <mat-icon>check_circle</mat-icon>
            <div>Already reviewed</div>
        </div>

        <div class="irv-toolbar" *ngIf="proposal.status === 'pending'">
            <span class="irv-toolbar__summary" data-test="summary">{{ summary }}</span>
            <span class="irv-toolbar__bulk">
                <button mat-button type="button" color="primary" (click)="setAll('accept')">File all</button>
                <button mat-button type="button" (click)="setAll('reject')">Leave all out</button>
            </span>
        </div>

        <section class="irv-section" *ngFor="let l of lists">
            <h3 class="irv-section__title">{{ l.label }}</h3>
            <div data-test="items">
                <div class="irv-row" *ngFor="let i of l.items" data-test="item"
                     [class.irv-row--missing]="submitAttempted && proposal.status === 'pending' && needsDecision(i)">
                    <mat-icon class="irv-row__icon irv-row__icon--{{ l.list }}" aria-hidden="true">{{ l.icon }}</mat-icon>
                    <div class="irv-row__body">
                        <div class="irv-row__main">{{ i.main }}</div>
                        <div class="irv-row__secondary" *ngIf="i.secondary">{{ i.secondary }}</div>
                    </div>
                    <div class="irv-row__control">
                        <span *ngIf="proposal.status !== 'pending' && proposal.decisions?.[i.itemId] as d" class="irv-chip"
                              [class.irv-chip--yes]="d === 'filed'">{{ outcomeLabels[d] || d }}</span>
                        <ng-container *ngIf="proposal.status === 'pending'">
                            <span class="irv-chip" *ngIf="i.alreadyRecorded"><mat-icon>check</mat-icon>Already in the record</span>
                            <mat-button-toggle-group *ngIf="!i.alreadyRecorded" class="irv-toggle" [(ngModel)]="decisions[i.itemId]" [attr.aria-label]="i.text">
                                <mat-button-toggle class="irv-toggle__yes" value="accept">File</mat-button-toggle>
                                <mat-button-toggle class="irv-toggle__no" value="reject">Leave out</mat-button-toggle>
                            </mat-button-toggle-group>
                        </ng-container>
                    </div>
                </div>
            </div>
        </section>

        <div class="irv-alert irv-alert--warning" *ngIf="proposal.status === 'pending' && submitAttempted && undecided.length" data-test="undecided">
            <mat-icon>rule</mat-icon>
            <div>Decide {{ undecided.length }} more {{ undecided.length === 1 ? 'item' : 'items' }} before saving.</div>
        </div>

        <div class="irv-alert irv-alert--error" *ngIf="actionError">
            <mat-icon>error_outline</mat-icon>
            <div>{{ actionError }}</div>
        </div>
    </ng-container>
</div>

<div mat-dialog-actions align="end">
    <button mat-button (click)="close()" [disabled]="isSaving">Close</button>
    <button mat-flat-button color="primary" *ngIf="proposal?.status === 'pending'" (click)="save()" [disabled]="isSaving" data-test="save">
        {{ isSaving ? 'Saving…' : 'Save decisions' }}
    </button>
</div>
